import Vue from 'vue';

/**
 * テンプレートのイベント就職子で使用できるキー設定。
 *
 * 起動時にmain.tsで読み込むと、
 * ```
 *    <input @keydown.minus="executeSomeAction" />
 *    <input @keydown.minus.prevent />
 * ```
 * などのように使用できる。
 *
 * // TODO: これはvue3では使えなくなるのでマイグレーションするのであれば注意する。
 * https://vueframework.com/docs/v3/ja/guide/migration/keycode-modifiers.html
 */
Object.assign(Vue.config.keyCodes, {
  period: 190,
  minus: 189,
  plus: 187,
});
